var _rect, _path, _path2, _rect2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppsIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 100,
    viewBox: "0 0 163 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81.5508,
    height: 81.531,
    rx: 2.88136,
    transform: "matrix(0.965944 -0.258751 0.258887 0.965908 0 21.2485)",
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.473 84.7364L80.267 72.2015L46.0688 38.169L33.473 84.7364ZM48.5577 47.4523L70.9379 69.7241L40.3147 77.9272L48.5577 47.4523Z",
    fill: "#001540"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.927 22.7156L27.8205 74.869L80.2278 60.8305L41.927 22.7156ZM44.7142 33.113L69.779 58.0561L35.4825 67.2433L44.7142 33.113Z",
    fill: "#0E2C66"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 81.5508,
    height: 81.531,
    rx: 2.88136,
    transform: "matrix(0.965944 0.258751 -0.258887 0.965908 84.2265 0)",
    fill: "#0E2D66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4622 71.7139L128.256 84.2488L115.661 37.6815L81.4622 71.7139ZM113.173 46.9651L121.416 77.4401L90.7928 69.2369L113.173 46.9651Z",
    fill: "#F9FAFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.803 22.2281L81.502 60.3431L133.909 74.3816L119.803 22.2281ZM117.016 32.6257L126.248 66.756L91.9515 57.5689L117.016 32.6257Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsIcons);
export default __webpack_public_path__ + "static/media/AppsIcons.4f33ceb4e31d1d0e168930c6803e57cf.svg";
export { ForwardRef as ReactComponent };